import { Injectable } from '@angular/core';
import { OverviewPortfolioGQL, OverviewParkGQL } from '../../graphql';
import { map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Overview } from 'app/models/monitor/overview.model';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable()
export class OverviewService {

  constructor(
    private overviewPortfolioGQL: OverviewPortfolioGQL,
    private overviewParkGQL: OverviewParkGQL
  ) { }

  public getOverviewPortfolioData(navigationDetails: NavigationDetails): Observable<Overview[]> {
      return this.overviewPortfolioGQL.subscribe({
        variables: {
          portfolioId: navigationDetails.selectedPortfolioId,
          parkIds: navigationDetails.selectedParksIds
        }
      }).pipe(
          map(result => {
            const parks = result.data.portfolios[0].parks;
            parks.sort((a, b) => {
              return a.fe_name.localeCompare(b.fe_name);
            });
            return parks.map(park => Overview.mapFromPortfolio(park))
          }),
      )
  }

  public getOverviewParkData(parkNameObservable: Observable<string>,
                             navigationDetails: NavigationDetails): Observable<Overview[]> {
      return combineLatest([
          parkNameObservable
      ]).pipe(
      distinctUntilChanged(),
      switchMap(([name]) => {
              return this.overviewParkGQL.subscribe({
                  variables: {
                  name, turbineIds: navigationDetails.selectedTurbineIds
                  }
              }).pipe(
                  map(result => result.data.parks[0].turbines.map(turbine => Overview.mapFromPark(turbine)))
              )
          }
      )
    );
  }
}
